export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";